import { Component, effect } from '@angular/core';
import { SidebarService } from '@shared/services/sidebar.service';
import { CommonModule } from '@angular/common';
import { BackdropComponent } from '../backdrop/backdrop.component';
import { RouterModule } from '@angular/router';
import { AppHeaderComponent } from '../app-header/app-header.component';
import { ModalHostComponent } from '@shared/components/ui/modal-host/modal-host.component';
import { UserPreferencesService, UserPreferences } from '@shared/services/usuario/user-preferences.service';
import { ThemeService } from '@shared/services/theme.service';
import { AppSidebarMenuComponent } from '../app-sidebar/app-sidebar-menu/app-sidebar-menu.component';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    AppHeaderComponent,
    BackdropComponent,
    ModalHostComponent,
    AppSidebarMenuComponent,
  ],
  templateUrl: './app-layout.component.html',
})
export class AppLayoutComponent {
  readonly isExpanded$;
  readonly isHovered$;
  readonly isMobileOpen$;

  constructor(
    public sidebarService: SidebarService,
    private userPreferencesService: UserPreferencesService,
    private themeService: ThemeService
  ) {
    this.isExpanded$ = this.sidebarService.isExpanded$;
    this.isHovered$ = this.sidebarService.isHovered$;
    this.isMobileOpen$ = this.sidebarService.isMobileOpen$;

    // Cargar preferencias locales primero
    const localPrefs = localStorage.getItem('userPreferences');
    if (localPrefs) {
      const prefs: UserPreferences = JSON.parse(localPrefs);
      if (prefs.theme === 'light' || prefs.theme === 'dark') {
        this.themeService.setTheme(prefs.theme);
      }
    }

    // Efecto que escucha el signal del servicio
    effect(() => {
      const prefs = this.userPreferencesService.preferences();

      if (prefs?.theme === 'light' || prefs?.theme === 'dark') {
        this.themeService.setTheme(prefs.theme);
        localStorage.setItem('userPreferences', JSON.stringify(prefs));
      }
    });

    // Pedir preferencias al backend para sincronizar
    this.userPreferencesService.getPreferences().subscribe({
      error: err => console.warn('No se pudieron cargar las preferencias del usuario', err),
    });
  }

  get containerClasses() {
    return [
      'flex-1',
      'transition-all',
      'duration-300',
      'ease-in-out',
      (this.isExpanded$ || this.isHovered$) ? 'xl:ml-[290px]' : 'xl:ml-[90px]',
      this.isMobileOpen$ ? 'ml-0' : ''
    ];
  }
}
